"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.readContextPrefs = readContextPrefs;
exports.readContextPrefsEntry = readContextPrefsEntry;
exports.setContextPrefs = setContextPrefs;
const path = __importStar(require("path"));
const fs = __importStar(require("fs-extra"));
/**
 * Read/write `.loom/context-prefs.json` — the persisted sidebar CONTEXT overrides
 * (Phase 3, design §4 Option B). Mode-agnostic per-target schema (§3 Option A):
 *
 *   { "<targetId>": { "include": string[], "exclude": string[] }, ... }
 *
 * This is the single source of write truth for context prefs; the MCP tools
 * (`loom_set_context_prefs` / `loom_get_context_prefs`) and the context resource
 * read path both go through here.
 */
const PREFS_RELATIVE = path.join('.loom', 'context-prefs.json');
function prefsPath(root) {
    return path.join(root, PREFS_RELATIVE);
}
function arr(v) {
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
}
function normalizeEntry(entry) {
    const e = entry && typeof entry === 'object' ? entry : {};
    return { include: arr(e.include), exclude: arr(e.exclude) };
}
/**
 * Read the whole prefs document. Missing file → `{}`. Malformed JSON (or a
 * non-object root) → `{}` — the file self-repairs on the next write rather than
 * throwing. Entry shapes are normalised so callers always get string arrays.
 */
async function readContextPrefs(root) {
    try {
        const raw = await fs.readFile(prefsPath(root), 'utf8');
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed))
            return {};
        const out = {};
        for (const [id, entry] of Object.entries(parsed)) {
            out[id] = normalizeEntry(entry);
        }
        return out;
    }
    catch {
        return {};
    }
}
/** Overrides for a single target. Missing entry → empty include/exclude. */
async function readContextPrefsEntry(root, targetId) {
    const prefs = await readContextPrefs(root);
    return prefs[targetId] ?? { include: [], exclude: [] };
}
async function writeContextPrefs(root, prefs) {
    const file = prefsPath(root);
    await fs.ensureDir(path.dirname(file));
    await fs.writeFile(file, JSON.stringify(prefs, null, 2) + '\n', 'utf8');
}
/**
 * Update one target's overrides and persist. **Replace semantics**: a provided
 * `include`/`exclude` array replaces that list wholesale (an unspecified list is
 * preserved) — this is what lets the sidebar express "un-exclude doc X" by sending
 * the new arrays without X. `reset: true` removes the target entry entirely (back to
 * pure auto). An entry that ends up empty is pruned so the file never accumulates
 * `{ include: [], exclude: [] }` noise. Returns the full updated prefs document.
 */
async function setContextPrefs(root, targetId, input) {
    const prefs = await readContextPrefs(root);
    if (input.reset) {
        delete prefs[targetId];
        await writeContextPrefs(root, prefs);
        return prefs;
    }
    const current = prefs[targetId] ?? { include: [], exclude: [] };
    const dedupe = (xs) => Array.from(new Set(xs));
    const next = {
        include: dedupe(input.include ?? current.include),
        exclude: dedupe(input.exclude ?? current.exclude),
    };
    if (next.include.length === 0 && next.exclude.length === 0) {
        delete prefs[targetId];
    }
    else {
        prefs[targetId] = next;
    }
    await writeContextPrefs(root, prefs);
    return prefs;
}
